import React from "react";
import { Box, CircularProgress } from "@mui/material";

const RoomAnalytics = ({ analytics, isLoading = false, isMobile = false }) => {
  const stats = [
    { label: "Rooms", value: analytics?.total_rooms ?? 0 },
    { label: "Total area", value: `${analytics?.total_area ?? 0} sqm` },
    { label: "Avg height", value: `${analytics?.avg_height ?? 0} m` },
    { label: "Total inclusions", value: analytics?.total_inclusions ?? 0 },
  ];

  const gridStyle = {
    display: "grid",
    gridTemplateColumns: isMobile ? "repeat(2, 1fr)" : "repeat(4, 1fr)",
    gap: "16px",
    marginBottom: "24px",
  };

  const cardStyle = {
    backgroundColor: "#fff",
    border: "1px solid #E5E7EB",
    borderRadius: "8px",
    padding: "16px",
    minHeight: "86px",
    boxSizing: "border-box",
  };

  if (isLoading) {
    return (
      <div style={gridStyle}>
        {[1, 2, 3, 4].map((i) => (
          <Box
            key={i}
            sx={{
              ...cardStyle,
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              backgroundColor: "#f3f4f6",
            }}
          >
            <CircularProgress size={20} />
          </Box>
        ))}
      </div>
    );
  }

  return (
    <div style={gridStyle}>
      {stats.map((item) => (
        <div key={item.label} style={cardStyle}>
          <p
            style={{
              fontSize: "14px",
              color: "#949daa",
              margin: 0,
              marginBottom: "4px",
            }}
          >
            {item.label}
          </p>
          <p
            style={{
              fontSize: "24px",
              fontWeight: 600,
              color: "#0d0d0e",
              margin: 0,
            }}
          >
            {item.value}
          </p>
        </div>
      ))}
    </div>
  );
};

export default RoomAnalytics;
